import get from 'lodash.get';
import {
  CorporatePage,
  DefaultMeta,
  TSectionDefault,
} from '../../../../../types/partner-page-types';
import { SelfItrPlans } from './self-itr-plans/self-itr-plans';

const defaultTitleDesc = {
  title: 'Self filing plans',
  description:
    'Your plan will be automatically selected as per your ITR details',
};

interface IITRSection {
  postData: CorporatePage;
  metaData: DefaultMeta;
}

export const ITRSection: React.FC<IITRSection> = ({
  postData,
  metaData,
}): JSX.Element => {
  const sectionDefaults: TSectionDefault = get(
    metaData,
    'section_defaults.self_itr',
    defaultTitleDesc
  );
  const slug = postData.slug;
  return (
    <>
      {metaData && postData?.self_itr.active ? (
        <SelfItrPlans
          heading={sectionDefaults.title}
          description={sectionDefaults.description}
          isActive={postData?.self_itr.active}
          slug={slug}
        />
      ) : null}
    </>
  );
};
